import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bibShape, accountShape } from '@bibliocommons/bc-prop-types';
import { bindAll } from '@bibliocommons/utils-react';
import { TransactionalSolidButton } from '@bibliocommons/base-buttons';
import TextField from '@bibliocommons/text-field';
import Checkbox from '@bibliocommons/base-checkbox';
import { ModalHeader, ModalContent, ModalFooter } from '@bibliocommons/modal';
import { BibBriefContainer } from 'app/components/bibs/shared/BibBrief';
import { MATERIAL_TYPE_DIGITAL } from 'app/constants/BibConstants';

import './DigitalHoldForm.scss';

export class DigitalHoldForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      digitalNotificationEmail: this.props.currentAccount?.get('digitalNotificationEmail'),
      autoCheckoutsEnabled: false
    };
    bindAll(this);
  }

  handleEmailChange(digitalNotificationEmail) {
    this.setState({
      digitalNotificationEmail
    });
  }

  handleAutoCheckoutChange(autoCheckoutsEnabled) {
    this.setState({
      autoCheckoutsEnabled
    });
  }

  handleDigitalHold() {
    const { holdActions, bib, handleClose, currentAccount } = this.props;
    const { digitalNotificationEmail, autoCheckoutsEnabled } = this.state;

    holdActions.placeHold({
      accountId: currentAccount.get('id'),
      metadataId: bib.get('id'),
      postSuccess: handleClose,
      materialType: MATERIAL_TYPE_DIGITAL,
      enableSingleClickHolds: false,
      materialParams: {
        email: digitalNotificationEmail,
        autoCheckout: autoCheckoutsEnabled
      }
    });
  }

  renderAutoCheckoutsCheckbox() {
    const supportAutoCheckout = this.props.bib.getIn(['policy', 'materialPolicy', 'supportAutoCheckout']);

    if (supportAutoCheckout) {
      return (
        <div className="digital-hold-auto-checkout">
          <Checkbox
            id="auto-checkout-checkbox"
            dataKey="auto-checkout-checkbox"
            aria-describedby="auto-checkout-description"
            label={<FormattedMessage id="enable_auto_checkout" />}
            checked={this.state.autoCheckoutsEnabled}
            handleChange={this.handleAutoCheckoutChange}
          />
          <div className="enable-auto-checkout-description" id="digital-hold-description">
            <FormattedMessage id="enable_auto_checkout_info" />
          </div>
        </div>
      );
    }

    return null;
  }

  renderNotificationEmailTextField() {
    return (
      <div className="digital-hold-notification-email">
        <TextField
          label={<FormattedMessage id="notification_email" />}
          type="email"
          id="digital-notification"
          onChange={this.handleEmailChange}
          value={this.state.digitalNotificationEmail}
          size="large"
        />
      </div>
    );
  }

  render() {
    const { bib, holdsTransactions, digitalFormats, intl } = this.props;
    const isPlacingHold = holdsTransactions.getIn([bib.get('id'), 'isPlacingHold'], false);
    const formatList = digitalFormats.map(digitalFormat => {
      return intl.formatMessage({
        id: `digiformat_${digitalFormat.get('name').toLowerCase()}`
      });
    });

    return (
      <div className="cp-digital-hold-form">
        <ModalHeader title={<FormattedMessage id="place_hold" />} />
        <ModalContent>
          <BibBriefContainer metadataId={bib.get('id')} />
          <div className="digital-hold-available-format">
            <FormattedMessage id="available_as" values={{ formats: formatList.join(', ') }} />
          </div>
          {this.renderNotificationEmailTextField()}
          {this.renderAutoCheckoutsCheckbox()}
        </ModalContent>
        <ModalFooter
          primaryActionButtonTag={TransactionalSolidButton}
          primaryActionButtonText={<FormattedMessage id="place_hold" />}
          isLoading={isPlacingHold}
          handlePrimaryAction={this.handleDigitalHold}
          disabled={!this.state.digitalNotificationEmail}
        />
      </div>
    );
  }
}

DigitalHoldForm.propTypes = {
  bib: bibShape.isRequired,
  handleClose: PropTypes.func.isRequired,
  holdsTransactions: ImmutablePropTypes.map.isRequired,
  digitalFormats: ImmutablePropTypes.list,
  holdActions: PropTypes.objectOf(PropTypes.func).isRequired,
  currentAccount: accountShape
};

export default injectIntl(DigitalHoldForm);
